export const graphqlBaseUrl = process.env.REACT_APP_BACKEND_URL;
